<form [formGroup]="accidentDataForm" *ngIf="accidentDetail">
  <div class="grid-col-3">
    <!-- Id SAP -->
    <div class="input-container">
      <span class="label">Id SAP</span>
      <div class="input">
        <input
          formControlName="serviceCallId"
          type="text"
          placeholder="Id SAP"
        />
      </div>
    </div>

    <!-- Causa del siniestro -->
    <div class="input-container">
      <span class="label">Causa del siniestro</span>
      <div class="input">
        <input
          formControlName="causaSiniestro"
          type="text"
          placeholder="Causa del siniestro"
        />
      </div>
    </div>

    <!-- Número de chasis -->
    <div class="input-container" [class.error]="numeroChasisHasError">
      <span class="label">Número de chasis</span>
      <div class="input">
        <input
          (input)="_updateEditAccidenteData()"
          formControlName="numeroChasis"
          type="text"
          placeholder="Número de chasis"
        />
      </div>
      <span class="error-message" *ngIf="numeroChasisHasError">{{
        numeroChasisErrorMessage
      }}</span>
    </div>

    <!-- Matricula -->
    <div class="input-container" [class.error]="matriculaHasError">
      <span class="label">Matrícula</span>
      <div class="input">
        <input
          (input)="_updateEditMatricula()"
          formControlName="matricula"
          type="text"
          placeholder="Matrícula"
        />
      </div>
      <span class="error-message" *ngIf="matriculaHasError">{{
        matriculaErrorMessage
      }}</span>
    </div>

    <!-- Origen de la denuncia -->
    <!-- <div class="input-container">
      <span class="label">Origen de la denuncia</span>
      <div class="input">
        <input
          formControlName="origenDenuncia"
          type="text"
          placeholder="Origen de la denuncia"
        />
      </div>
    </div> -->

    <!-- Estado del siniestro -->
    <div class="input-container">
      <span class="label">Estado del siniestro</span>
      <div class="input">
        <input
          formControlName="estado"
          type="text"
          placeholder="Estado del siniestro"
        />
      </div>
    </div>

    <!-- Sub Estado del siniestro -->
    <div class="input-container">
      <span class="label">Sub estado del siniestro</span>
      <div class="input">
        <input
          formControlName="subEstado"
          type="text"
          placeholder="Sub estado del siniestro"
        />
      </div>
    </div>

    <!-- Liquidador interno -->
    <div class="input-container">
      <span class="label">Liquidador interno</span>
      <div class="input">
        <input
          formControlName="liquidadorInterno"
          type="text"
          placeholder="Liquidador interno"
        />
      </div>
    </div>

    <!-- Serie de service call -->

    <!-- Fecha de ocurrencia -->
    <div class="input-container" [class.error]="fechaDeOcurrenciaHasError">
      <span class="label">Fecha de ocurrencia</span>
      <div class="input" *ngIf="!canEditFechaHoraOcurrencia">
        <input
          formControlName="fechaDeOcurrencia"
          type="text"
          placeholder="Fecha de ocurrencia"
        />
        <i class="fas fa-calendar-alt"></i>
      </div>
      <div class="input" *ngIf="canEditFechaHoraOcurrencia">
        <p-datepicker
          formControlName="fechaDeOcurrencia"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [maxDate]="maxFechaOcurrencia"
          [defaultDate]="maxFechaOcurrencia"
          (onSelect)="_updateEditFechaHoraOcurrencia()"
        />
      </div>
      <span class="error-message" *ngIf="fechaDeOcurrenciaHasError">{{
        fechaDeOcurrenciaErrorMessage
      }}</span>
    </div>

    <!-- Hora de ocurrencia -->
    <div class="input-container" [class.error]="horaDeOcurrenciaHasError">
      <span class="label">Hora de ocurrencia</span>
      <div class="input">
        <input
          (input)="_updateEditFechaHoraOcurrencia()"
          formControlName="horaDeOcurrencia"
          type="text"
          placeholder="Hora de ocurrencia (HH:mm:ss)"
        />
        <i class="fas fa-clock"></i>
      </div>
      <span class="error-message" *ngIf="horaDeOcurrenciaHasError">{{
        horaDeOcurrenciaErrorMessage
      }}</span>
    </div>

    <!-- Fecha de denuncia -->
    <div class="input-container">
      <span class="label">Fecha de denuncia</span>
      <div class="input">
        <input
          formControlName="fechaDeDenuncia"
          type="text"
          placeholder="Fecha de denuncia"
        />
        <i class="fas fa-calendar-alt"></i>
      </div>
    </div>

    <!-- Subclase de negocio -->
    <div class="input-container">
      <span class="label">Subclase de negocio</span>
      <div class="input">
        <input
          formControlName="subclaseNegocio"
          type="text"
          placeholder="Subclase de negocio"
        />
      </div>
    </div>

    <!-- Cobertura confirmada -->
    <div class="input-container">
      <span class="label">Cobertura confirmada</span>

      <label class="custom-radio-button-container"
        >Si
        <input
          formControlName="coberturaConfirmada"
          [value]="true"
          type="radio"
          name="coberturaConfirmada"
        />
        <span class="checkmark"></span>
      </label>

      <label class="custom-radio-button-container"
        >No
        <input
          formControlName="coberturaConfirmada"
          [value]="false"
          type="radio"
          name="coberturaConfirmada"
        />
        <span class="checkmark"></span>
      </label>
    </div>

    <!-- Codigo de causa del siniestro -->
    <div class="input-container">
      <span class="label">Código de causa del siniestro</span>
      <div class="input">
        <input
          formControlName="codigoCausa"
          type="text"
          placeholder="Código de causa del siniestro"
        />
      </div>
    </div>

    <!-- Descripcion de causa del siniestro -->
    <div class="input-container">
      <span class="label">Descripción de causa del siniestro</span>
      <div class="input">
        <input
          formControlName="descripcionCausa"
          type="text"
          placeholder="Descripción de causa del siniestro"
        />
      </div>
    </div>

    <!-- Fecha de apertura de siniestro -->
    <div class="input-container">
      <span class="label">Fecha de apertura de siniestro</span>
      <div class="input">
        <input
          formControlName="fechaDeApertura"
          type="text"
          placeholder="Fecha de apertura de siniestro"
        />
        <i class="fas fa-calendar-alt"></i>
      </div>
    </div>

    <!-- Envío de notificación a whatsapp -->
    <!-- <div class="input-container">
      <span class="label">Envío de notificación a whatsapp</span>

      <label class="custom-radio-button-container"
        >Si
        <input
          type="radio"
          formControlName="envioNotificacionWhatsapp"
          [value]="true"
          name="envioNotificacionWhatsapp"
        />
        <span class="checkmark"></span>
      </label>

      <label class="custom-radio-button-container"
        >No
        <input
          type="radio"
          formControlName="envioNotificacionWhatsapp"
          [value]="false"
          name="envioNotificacionWhatsapp"
        />
        <span class="checkmark"></span>
      </label>
    </div> -->

    <!-- Envío de notificación al email -->
    <!-- <div class="input-container">
      <span class="label">Envío de notificación al email</span>

      <label class="custom-radio-button-container"
        >Si
        <input
          type="radio"
          formControlName="envioNotificacionEmail"
          [value]="true"
          name="envioNotificacionEmail"
        />
        <span class="checkmark"></span>
      </label>

      <label class="custom-radio-button-container"
        >No
        <input
          type="radio"
          formControlName="envioNotificacionEmail"
          [value]="false"
          name="envioNotificacionEmail"
        />
        <span class="checkmark"></span>
      </label>
    </div> -->

    <!-- Descripción del hecho -->
    <div class="input-container input-comentarios-adicionales">
      <span class="label">Descripción del hecho</span>
      <div class="input">
        <textarea
          formControlName="descripcionDelHecho"
          placeholder="Descripción del hecho"
        ></textarea>
      </div>
    </div>

    <!-- Comentarios adicionales del denunciante -->
    <div class="input-container input-comentarios-adicionales">
      <span class="label">Comentarios adicionales del denunciante</span>
      <div class="input">
        <textarea
          formControlName="comentariosAdicionales"
          placeholder="Comentarios adicionales del denunciante"
        ></textarea>
      </div>
    </div>
  </div>

  <div class="subtitle"><i class="fas fa-user"></i>Primer Testigo</div>
  <div class="grid-col-3">
    <!-- Nombre -->
    <div class="input-container">
      <span class="label">Nombre</span>
      <div class="input">
        <input
          formControlName="primerTestigoNombre"
          type="text"
          placeholder="Nombre"
        />
      </div>
    </div>
    <!-- Apellido -->
    <div class="input-container">
      <span class="label">Apellido</span>
      <div class="input">
        <input
          formControlName="primerTestigoApellido"
          type="text"
          placeholder="Apellido"
        />
      </div>
    </div>
    <!-- Tipo documento -->

    <div class="input-container">
      <span class="label">Tipo documento</span>
      <div class="input">
        <input
          formControlName="primerTestigoTipoDocumento"
          type="text"
          placeholder="Tipo documento"
        />
      </div>
    </div>
    <!-- Nro Documento -->
    <div class="input-container">
      <span class="label">Nro Documento</span>
      <div class="input">
        <input
          formControlName="primerTestigoNroDocumento"
          type="text"
          placeholder="Nro Documento"
        />
      </div>
    </div>
    <!-- Email -->
    <div class="input-container">
      <span class="label">Email</span>
      <div class="input">
        <input
          formControlName="primerTestigoEmail"
          type="text"
          placeholder="Email"
        />
      </div>
    </div>
    <!-- Telefono -->
    <div class="input-container">
      <span class="label">Teléfono</span>
      <div class="input">
        <input
          formControlName="primerTestigoTelefono"
          type="text"
          placeholder="Teléfono"
        />
      </div>
    </div>
    <!-- Direccion -->
    <div class="input-container">
      <span class="label">Dirección</span>
      <div class="input">
        <input
          formControlName="primerTestigoDireccion"
          type="text"
          placeholder="Dirección"
        />
      </div>
    </div>
  </div>
  <div class="subtitle"><i class="fas fa-user"></i>Segundo Testigo</div>
  <div class="grid-col-3">
    <!-- Nombre -->
    <div class="input-container">
      <span class="label">Nombre</span>
      <div class="input">
        <input
          formControlName="segundoTestigoNombre"
          type="text"
          placeholder="Nombre"
        />
      </div>
    </div>
    <!-- Apellido -->
    <div class="input-container">
      <span class="label">Apellido</span>
      <div class="input">
        <input
          formControlName="segundoTestigoApellido"
          type="text"
          placeholder="Apellido"
        />
      </div>
    </div>
    <!-- Tipo documento -->
    <div class="input-container">
      <span class="label">Tipo documento</span>
      <div class="input">
        <input
          formControlName="segundoTestigoTipoDocumento"
          type="text"
          placeholder="Tipo documento"
        />
      </div>
    </div>
    <!-- Nro Documento -->
    <div class="input-container">
      <span class="label">Nro Documento</span>
      <div class="input">
        <input
          formControlName="segundoTestigoNroDocumento"
          type="text"
          placeholder="Nro Documento"
        />
      </div>
    </div>
    <!-- Email -->
    <div class="input-container">
      <span class="label">Email</span>
      <div class="input">
        <input
          formControlName="segundoTestigoEmail"
          type="text"
          placeholder="Email"
        />
      </div>
    </div>
    <!-- Telefono -->
    <div class="input-container">
      <span class="label">Teléfono</span>
      <div class="input">
        <input
          formControlName="segundoTestigoTelefono"
          type="text"
          placeholder="Teléfono"
        />
      </div>
    </div>
    <!-- Direccion -->
    <div class="input-container">
      <span class="label">Dirección</span>
      <div class="input">
        <input
          formControlName="segundoTestigoDireccion"
          type="text"
          placeholder="Dirección"
        />
      </div>
    </div>
  </div>
  <!-- Ampliación Testigos -->
  <div class="input-container">
    <span class="label">Ampliación Testigos</span>
    <div class="input">
      <textarea
        formControlName="segundoTestigoAmpliacionTestigos"
        placeholder="Ampliación Testigos"
      ></textarea>
    </div>
  </div>

  <div class="subtitle">
    <i class="fas fa-clipboard"></i>Cuestionario de Hurto total
  </div>
  <div class="grid-col-2">
    <!-- Fecha y hora de llegada -->
    <div class="input-container">
      <span class="label">Fecha y hora de llegada</span>
      <div class="input">
        <input
          formControlName="cuestionarioFechaLlegada"
          type="text"
          placeholder="Fecha y hora de llegada"
        />
        <i class="fas fa-calendar-alt"></i>
      </div>
    </div>
    <!-- Fecha y hora del hurto -->
    <div class="input-container">
      <span class="label">Fecha y hora del hurto</span>
      <div class="input">
        <input
          formControlName="cuestionarioFechaHurto"
          type="text"
          placeholder="Fecha y hora del hurto"
        />
        <i class="fas fa-calendar-alt"></i>
      </div>
    </div>
    <!-- Lugar del hecho -->
    <div class="input-container">
      <span class="label">Lugar del hecho</span>
      <div class="input">
        <input
          formControlName="cuestionarioLugar"
          type="text"
          placeholder="Lugar del hecho"
        />
      </div>
    </div>
    <!-- Juegos de llaves -->
    <div class="input-container">
      <span class="label">¿Cuántos juegos de llaves posee su vehículo?</span>
      <div class="input">
        <input
          formControlName="cuestionarioNroJuegoLlaves"
          type="text"
          placeholder="Nro juegos llaves del vehículo"
        />
      </div>
    </div>
    <!-- Cantidad de llaves en el llavero -->
    <div class="input-container">
      <span class="label">¿El llavero de cuantas llaves consta?</span>
      <div class="input">
        <input
          formControlName="cuestionarioCantidadLlaves"
          type="text"
          placeholder="Nro llaves del vehículo en el llavero"
        />
      </div>
    </div>
    <!-- Indicios de forcejeo -->
    <div class="input-container">
      <span class="label">¿Notó indicios de forcejeo anteriormente?</span>
      <div class="input">
        <input
          formControlName="cuestionarioIndiciosForcejeo"
          type="text"
          placeholder="Indicios de forcejeo"
        />
      </div>
    </div>
    <!-- Sistemas de seguridad -->
    <div class="input-container">
      <span class="label">¿Qué sistemas de seguridad posee?</span>
      <div class="input">
        <input
          formControlName="cuestionarioSistemasSeguridad"
          type="text"
          placeholder="Sistemas de seguridad"
        />
      </div>
    </div>
    <!-- Cantidad de activadores -->
    <div class="input-container">
      <span class="label"
        >¿Qué cantidad de activadores posee en este momento?</span
      >
      <div class="input">
        <input
          formControlName="cuestionarioCantidadActivadores"
          type="text"
          placeholder="Cantidad de activadores"
        />
      </div>
    </div>
    <!-- Extravio o hurto de juego de llames -->
    <div class="input-container">
      <span class="label"
        >¿Extravió o fue objeto de hurto de algún juego de llaves?</span
      >
      <div class="input">
        <input
          formControlName="cuestionarioExtravioJuegoLlaves"
          type="text"
          placeholder="Extravió o hurto de algún juego de llaves"
        />
      </div>
    </div>
    <!-- Otra persona al dejar el vehiculo -->
    <div class="input-container">
      <span class="label"
        >¿Se encontraba con otra persona cuando dejó el vehículo?</span
      >
      <div class="input">
        <input
          formControlName="cuestionarioOtraPersona"
          type="text"
          placeholder="Otra persona cuando dejó el vehículo"
        />
      </div>
    </div>
    <!-- Otra persona durante hurto -->
    <div class="input-container">
      <span class="label"
        >¿Se encontraba con otra persona cuando constató el hurto?</span
      >
      <div class="input">
        <input
          formControlName="cuestionarioOtraPersonaDuranteHurto"
          type="text"
          placeholder="Otra persona cuando constató el hurto"
        />
      </div>
    </div>
    <!-- Ciruculacion vehiculo -->
    <div class="input-container">
      <span class="label"
        >¿Dónde circula o permanece el vehículo un 90% del tiempo?</span
      >
      <div class="input">
        <input
          formControlName="cuestionarioCirculacionVehiculo"
          type="text"
          placeholder="Lugar donde circula o permanece el vehículo"
        />
      </div>
    </div>
    <!-- Color del vehiculo -->
    <div class="input-container">
      <span class="label">Color del vehículo y si presentaba daños</span>
      <div class="input">
        <input
          formControlName="cuestionarioColorVehiculo"
          type="text"
          placeholder="Color del vehículo y si presentaba daños"
        />
      </div>
    </div>
    <!-- Frente de radio -->
    <div class="input-container">
      <span class="label">¿Presenta frente de radio?</span>
      <div class="input">
        <input
          formControlName="cuestionarioFrenteRadio"
          type="text"
          placeholder="¿Presenta frente de radio?"
        />
      </div>
    </div>
    <!-- Marca y modelo radio -->
    <div class="input-container">
      <span class="label">Marca y modelo de la radio</span>
      <div class="input">
        <input
          formControlName="cuestionarioMarcaRadio"
          type="text"
          placeholder="Marca y modelo de la radio"
        />
      </div>
    </div>
  </div>
  <!-- Observaciones -->
  <div class="input-container">
    <span class="label">Observaciones</span>
    <div class="input">
      <textarea
        formControlName="cuestionarioObservaciones"
        placeholder="Observaciones"
      ></textarea>
    </div>
  </div>
</form>
